import styled from 'styled-components'

export const HeaderMain = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const HeaderTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  border-radius: 0 27px 0 27px;
  color: #ffffff;
  font-family: 'Montserrat', sans-serif;
  z-index: 200000;

  p:nth-child(1) {
    font-size: 16px;
    font-weight: 800;
  }

  p:nth-child(2) {
    font-size: 15px;
    font-style: italic;
  }
`

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  width: 99%;
  height: 80px;
  border-radius: 27px;

  @media (max-width: 1400px) {
    width: 98%;
    overflow-x: scroll;
  }

  @media (max-width: 700px) {
    width: 97%;
    overflow-x: scroll;
    padding: 0 0 0 40px;
  }

  @media (max-width: 600px) {
    width: 97%;
    overflow-x: scroll;
    padding: 0 0 0 0px;
  }

  @media (max-width: 500px) {
    width: 95%;
    overflow-x: scroll;
    padding: 0 0 0 0px;
  }

  @media (max-width: 500px) {
    width: 95%;
    overflow-x: scroll;
    padding: 0 0 0 0px;
  }
`
